declare global {
    interface Window {
        dataLayer?: unknown[];
    }
}

const MODAL_DATA_EVENT_NAME = 'modal';

type ModalEvent = {
    event: string;
} & ModalDataEvent;

type ModalAction = 'open' | 'close';

export type ModalDataEvent = {
    modal_name?: string;
    modal_description?: string;
    modal_action: ModalAction;
    app_namespace?: string;
};

const pushModalDataEvent = (dataEvent: ModalDataEvent) => {
    const modalEvent: ModalEvent = {
        event: MODAL_DATA_EVENT_NAME,
        ...dataEvent,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(modalEvent);
};

export default pushModalDataEvent;
